import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const employeeInfoRequest = createRequest(constants.employeeInfo);
export const employeeInfoSuccess = createSuccess(constants.employeeInfo);
export const employeeInfoFailure = createFailure(constants.employeeInfo);

export const requestEmployeeInfo = employeeInfoRequest;
